import { Icon, IconButton, useToken } from '@chakra-ui/react'
import { useState } from 'react'
import { BsFiletypeCsv } from 'react-icons/bs'
import { FiChevronDown } from 'react-icons/fi'
import { HiOutlineLockClosed } from 'react-icons/hi'
import { SiGooglesheets } from 'react-icons/si'
import { Link, useLocation } from 'react-router-dom'

import { MenuContent, MenuItem, MenuRoot, MenuSeparator, MenuTrigger } from '@app/components/ui/menu'
import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import GoogleSheetsConnectModal from '@app/pages/metrics/components/googleSheetsConnectModal'
import GoogleSheetsMenuGroup from '@app/pages/metrics/components/googleSheetsMenuGroup'
import MetricCSVModal from '@app/pages/metrics/components/metricCSVModal'
import Can from '@app/shared/authorization/can'

const ListActionsMenu = () => {
  const location = useLocation()
  const [csvOpen, setCsvOpen] = useState(false)
  const [sheetsConnectOpen, setSheetsConnectOpen] = useState(false)
  const googleSheet = useGetObjectsByProperties('googleSheet', { organizationLevel: true })?.[0]

  const oauthState = {
    redirect_to: location.pathname,
    type: 'organization' as const
  }

  const green = useToken('colors', 'green.500')

  return (
    <>
      <MetricCSVModal open={csvOpen} setOpen={setCsvOpen} />
      <GoogleSheetsConnectModal
        open={sheetsConnectOpen}
        onOpenChange={(e) => setSheetsConnectOpen(e.open)}
        state={oauthState}
      />
      <MenuRoot>
        <MenuTrigger asChild>
          <IconButton variant="surface">
            <FiChevronDown />
          </IconButton>
        </MenuTrigger>
        <MenuContent>
          <MenuItem value="metric_csv" onClick={() => setCsvOpen(true)}>
            <BsFiletypeCsv /> Upload CSV
          </MenuItem>
          <MenuSeparator />
          <MenuItem value="credentials">
            <HiOutlineLockClosed />
            <Link to="credentials">Credentials</Link>
          </MenuItem>
          <MenuSeparator />
          <Can I="create" a="googleSheet">
            <MenuItem value="connect_to_google_sheets" onClick={() => setSheetsConnectOpen(true)}>
              <Icon color={green}>
                <SiGooglesheets />
              </Icon>
              Connect to Google Sheets
            </MenuItem>
          </Can>
          {googleSheet && <GoogleSheetsMenuGroup googleSheet={googleSheet} />}
        </MenuContent>
      </MenuRoot>
    </>
  )
}

export default ListActionsMenu
